import { useState } from 'react'
import styled from 'styled-components'
import BottomSheetLayout from './common/BottomSheetLayout'
import LabeledInput from './LabeledInput'
import Text from '../atoms/Text'
import ErrorableInputWrapper from './common/ErrorableInputWrapper'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
`
const Header = styled.div`
  position: relative;
`
const SaveButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  background: none;
  border: none; 
`
const AddMeaningBottomSheet = ({ $isOpen, onClose, word, onSaveMeaning }) => {
  const [meaning, setMeaning] = useState('')
  const [error, setError] = useState('')
  
  const handleChange = (e) => {
    setMeaning(e.target.value)
  }

  const validateMeaning = () => {
    const trimmedMeaning = meaning.trim();
    if (!trimmedMeaning) {
      setError('의미단어를 입력해주세요.');
      return false;
    }

    const recommendedMeanings = word.rate.map(r => r.meaning);
    if (recommendedMeanings.includes(trimmedMeaning)) {
      setError('추천단어와 동일한 단어는 등록할 수 없습니다.');
      return false;
    }
    setError('');
    return true;
  };

  const handleBlur = () => {
    validateMeaning();
  }

  const handleSave = () => {
    if (!validateMeaning()) return;
    onSaveMeaning(meaning)
  }

  return (
    <BottomSheetLayout $isOpen={$isOpen} onClose={onClose}>
      <>
        <Header>
          <Text variant="headline3" weight="medium">의미단어 등록</Text>
          <SaveButton onClick={handleSave}>
            <Text variant="headline3" weight="medium" color="assistive">저장</Text>
          </SaveButton>
        </Header>
        <Wrapper>
          <LabeledInput
            label="발화내용"
            value={word.content}
            readOnly={true}/>
          <ErrorableInputWrapper error={error} message={error}>
            <LabeledInput
              label="의미단어"
              value={meaning}
              onChange={handleChange}
              onBlur={handleBlur}
              required={true}/>
          </ErrorableInputWrapper>
        </Wrapper>
       
      </>
    </BottomSheetLayout>
  )
}

export default AddMeaningBottomSheet
